import { defineMessages } from 'react-intl';

const messages = defineMessages({
  artistAttribution: {
    defaultMessage: 'by {artistName}',
    description: 'The artist who created this work.'
  }
});

export default messages;
